var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes, attrs: { "aria-hidden": !_vm.isVisible } },
    [
      _c("div", { staticClass: "explanation-header" }, [
        _vm._v(_vm._s(_vm.explanationHeader)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "explanation-details",
        domProps: { innerHTML: _vm._s(_vm.sanitizedExplanation) },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }